import React from 'react'
import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import Fact from '../Fact'

// A signature counts when the whole signature or its name check succeeded
const isSigned = (signature) =>
  signature?.success === true || signature?.success?.name === true

// The registry shows this section to iBoxen only, and only for a parcel that
// has signatures.
export default function Signatures({ parcel }) {
  const { t } = useTranslation('parcels')

  const signatures = parcel.signatures || []
  if (signatures.length === 0) return null

  const receiverPhone = parcel.receiver?.phoneNumber
  const bankIdMatched = signatures.some(
    (signature) =>
      receiverPhone &&
      signature.phoneNumber === receiverPhone &&
      isSigned(signature)
  )
  const ageSignature = signatures.find(
    (signature) => typeof signature?.success?.age === 'boolean'
  )
  let ageResult = t('notSigned')
  if (ageSignature) {
    ageResult = ageSignature.success.age ? t('signed') : t('signFailed')
  }

  return (
    <Stack spacing={0.5}>
      <Fact label={t('bankId')}>
        {bankIdMatched ? t('bankIdMatched') : t('bankIdNotMatched')}
      </Fact>
      {signatures.map((signature, i) => (
        // a signature has no id of its own, and two can share a phone number
        // eslint-disable-next-line react/no-array-index-key
        <Typography key={`${signature.phoneNumber}-${i}`} variant="body2">
          {isSigned(signature) ? '✔' : '✖'} {signature.name}
        </Typography>
      ))}
      {parcel.ageControl ? (
        <Typography variant="body2">
          {t('ageControlResult', { age: parcel.ageControl, result: ageResult })}
        </Typography>
      ) : null}
    </Stack>
  )
}
